import React from 'react';
import Gasto from './Gasto';
import PropTypes from 'prop-types';

const Listado = ({Gastos}) => {
    return ( 
        <div className="gastos-realizados">
            <h2>Listado</h2>
            {Gastos.map(gasto =>(
                <Gasto
                    key={gasto.id}
                    Gasto = {gasto}
                />

            ))}
        </div>

     );
}


Listado.propTypes = {
    Gastos: PropTypes.array.isRequired
}
 
export default Listado;